import React, { FC, ReactNode } from "react";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import { Button } from "../../../components/Button/Button";

export interface PostSuccessDialogProps {
  icon: JSX.Element;
  title: string;
  text: string | ReactNode;
  subText?: string | ReactNode;
  onClose: () => void;
  actions?: Array<JSX.Element>;
}

export const PostSuccessDialog: FC<PostSuccessDialogProps> = ({
  icon,
  title,
  text,
  subText,
  onClose,
  actions,
}) => (
  <Dialog open onClose={onClose}>
    <DialogContent className="flex flex-col gap-6 items-center text-center w-[400px] max-sm:w-auto max-sm:max-w-[400px]">
      <Box className="w-full items-center justify-center flex flex-col">
        {icon}

        <Typography variant="h5" className="py-4">
          {title}
        </Typography>

        <Box className="flex flex-col">
          <Typography variant="body2" className="text-text-2">
            {text}
          </Typography>
          {subText && (
            <Typography
              variant="body2"
              className="!font-[CircularStdBlack]"
            >
              {subText}
            </Typography>
          )}
        </Box>
      </Box>
      <Box className="flex gap-4 items-center justify-center w-full">
        {actions ?? (
          <Button onClick={onClose} variant="contained" className="py-4">
            Go to Projects
          </Button>
        )}
      </Box>
    </DialogContent>
  </Dialog>
);
